import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from './AuthContext';

const LoginRequired = ({ children }) => {
  const { isAuthenticated } = useContext(AuthContext);
  const location = useLocation();

  if (isAuthenticated) {
    return children;
  }
  return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
};

export default LoginRequired;
